import React from 'react';

interface HelpIconProps {
  size?: number;
  className?: string;
}

/**
 * The "Report a bug" mark: a circled question mark drawn in the same hand as
 * BulbIcon (24-unit box, 2px stroke, round caps and joins) so the two sit side
 * by side in the sidebar and the task panel footer as one family. The stock
 * Heroicons outline it replaced was a 1.5px stroke with a thin, tight hook and
 * read as a lighter, different icon beside the bulb (Aima, 2026-10-15).
 */
export const HelpIcon: React.FC<HelpIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3" />
    <path d="M12 17h.01" />
  </svg>
);

export default HelpIcon;
